/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Colors, Text } from '@zapier/design-system';
import { Fragment } from 'react';

const UpdateStyleIcon = (update: 'increase' | 'decrease') => css`
  background-color: ${update === 'increase'
    ? Colors.StatusSuccessStronger
    : Colors.StatusErrorStronger};
  clip-path: ${update === 'increase'
    ? 'polygon(50% 0, 100% 100%, 0 100%)'
    : 'polygon(0 0, 100% 0, 50% 100%)'};
  width: 18px;
  height: 18px;
`;

type CountDisplayProps = {
  count: number;
  label?: string;
  changeInfo?: {
    change: 'increase' | 'decrease';
    percent: number;
  };
};

const displayStyles = css`
  // The & character increases specificity for the style
  &&&&&&& > p {
    font-size: 60px;
    line-height: 76px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const CountDisplay = ({ count, label, changeInfo }: CountDisplayProps) => {
  const { change, percent } = changeInfo || {};
  return (
    <div css={displayStyles}>
      <Text fontWeight={600} margin="10px" tag="p" type="SectionHeader">
        {count.toLocaleString()}
        {label && (
          <Text fontWeight={600} tag="p" textAlign="center">
            {label}
          </Text>
        )}
      </Text>
      {change && percent && (
        <Fragment>
          <div css={UpdateStyleIcon(change)}></div>
          <Text color="StatusSuccessStronger" type="Body4">
            {percent}%
          </Text>
        </Fragment>
      )}
    </div>
  );
};

export default CountDisplay;
